import * as React from 'react';
import type { ButtonHTMLAttributes } from 'react';
import { cx } from '../utils';
import { JIcon } from '../../icons';

export interface AccordionTriggerProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'className'
> {
  open?: boolean;
  controls?: string;
  className?: string;
}

export const AccordionTrigger = React.forwardRef<HTMLButtonElement, AccordionTriggerProps>(
  function AccordionTrigger({ open, onClick, children, controls, className, style, ...rest }, ref) {
    return (
      <button
        {...rest}
        ref={ref}
        type="button"
        className={cx('j-accordion-trigger', className)}
        data-open={open ? 'true' : undefined}
        aria-expanded={open ? 'true' : 'false'}
        aria-controls={controls}
        onClick={onClick}
        style={style}
      >
        <span className="j-accordion-chevron">
          <JIcon intent="chevron-down" size={10} aria-hidden="true" />
        </span>
        {children}
      </button>
    );
  },
);
